import axios from 'axios'
import router from '../../router'

const BASE_URL = ''

export default {
  state: {
    status: '',
    rules: [],
    accessToken: localStorage.getItem('accessToken') || '',
    refreshToken: localStorage.getItem('refreshToken') || '',
    refreshRequest: null
  },

  getters: {
    isAuth(state) {
      return state.status === 'auth'
    },
    getRules(state) {
      return state.rules
    }
  },



  mutations: {

    setStatus(state, status) {
      state.status = status
    },

    setTokens(state, payload) {
      state.accessToken = payload.accessToken
      state.refreshToken = payload.refreshToken
      state.rules = payload.rules || []
      localStorage.setItem('accessToken', payload.accessToken)
      localStorage.setItem('refreshToken', payload.refreshToken)
      axios.defaults.headers.common['Authorization'] = payload.accessToken
    },

    removeTokens(state) {
      state.accessToken = ''
      state.refreshToken = ''
      state.rules = []
      localStorage.removeItem(['accessToken', 'refreshToken'])
      delete axios.defaults.headers.common['Authorization']
    }
  },

  actions: {
    login({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.post(BASE_URL + '/api/signIn', payload)
          .then(({ data, status }) => {
            if (status === 200) {
              commit('setTokens', {
                accessToken: data.accessToken,
                refreshToken: data.refreshToken,
                rules: data.rules
              })
              commit('setStatus', 'auth')
              resolve(true)
            }
          })
          .catch(error => {
            reject(error);
          })
      })
    },

    async logout({ state, commit }) {
      await axios.post(BASE_URL + '/api/singOut', { refreshToken: state.refreshToken })
      commit('removeTokens')
      commit('setStatus', 'logout')
    },

    async setupAxios({ state, commit }) {

      /*if (state.accessToken) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${state.accessToken}`
      }
      */

      if (state.refreshToken && state.accessToken) {
        commit('setTokens', {
          accessToken: state.accessToken,
          refreshToken: state.refreshToken,
          rules: 'data.rules'
        })
      }

      // if (state.refreshToken) {
      //   console.log(state.refreshToken)
      //   try {
      //     const { data } = await axios.post(BASE_URL + '/api/refreshTokens', { refreshToken: state.refreshToken })
      //     commit('setTokens', {
      //       accessToken: data.accessToken,
      //       refreshToken: data.refreshToken,
      //       rules: data.rules
      //     })
      //     commit('setStatus', 'auth')
      //   } catch (e) {
      //     console.log(e);
      //     commit('setStatus', 'logout')
      //     commit('removeTokens')
      //   }
      // }

      axios.interceptors.response.use(r => r,
        async error => {

          if (!state.refreshToken ||
            error.response.status !== 401 ||
            error.config.retry) {
            throw error
          }

          if (!state.refreshRequest) {
            state.refreshRequest = axios.post(BASE_URL + '/api/refreshTokens', {
              refreshToken: state.refreshToken
            })
          }

          try {
            const { data } = await state.refreshRequest
            commit('setTokens', {
              accessToken: data.accessToken,
              refreshToken: data.refreshToken,
              rules: data.rules
            })
            commit('setStatus', 'auth')
            error.config.headers.Authorization = data.accessToken;
            const newRequest = {
              ...error.config,
              retry: true
            }
            return axios(newRequest)
          } catch (e) {
            commit('setStatus', 'logout')
            commit('removeTokens')
            router.push('/login')
          } finally {
            state.refreshRequest = null
          }
        })
    }
  }
}
